var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_503_1553)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_503_1553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 24.9686C15.9326 24.9686 18.9848 23.7043 21.2353 21.4539C23.4857 19.2035 24.75 16.1512 24.75 12.9686C24.75 9.78603 23.4857 6.73378 21.2353 4.48335C18.9848 2.23291 15.9326 0.968628 12.75 0.968628C9.5674 0.968628 6.51516 2.23291 4.26472 4.48335C2.01428 6.73378 0.75 9.78603 0.75 12.9686C0.75 16.1512 2.01428 19.2035 4.26472 21.4539C6.51516 23.7043 9.5674 24.9686 12.75 24.9686Z",
    fill: "#1377D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4424 7.73779L11.0578 16.9686L7.36548 14.1993",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_503_1553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.75 0.968628)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_503_1553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.75 0.968628)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackComplete);
export default __webpack_public_path__ + "static/media/track-complete.c17a0d596be40f0baf272faab213bc16.svg";
export { ForwardRef as ReactComponent };